module.exports = __webpack_public_path__ + "static/media/icons8-user-location.9299f838.svg";